// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__wT3V+","noContent":"styles_noContent__G6jwg"};